export default function prepare_get_params_to_redirect(params) {
  var data = '?';
  Object.keys(params).forEach(function (item) {
    if (
      typeof params[item] !== 'undefined' &&
      params[item] !== '' &&
      params[item] !== 0
    ) {
      data += '&' + item + '=' + encodeURIComponent(params[item]);
    }
  });
  return data;
}